


/**
 * MessageNumber class
 */
export class MessageNumber {

    __value = 1;

    get = () => {
        return this.__value;
    }
    /**
     * sets the massage number
     * @param {number} value 
     */
    set = (value) => {
        this.__value = parseInt(value);
        return this;
    }
    increment = () => {
        this.__value++;
        return this;
    }
    decrement = () => {
        this.__value--;
        return this;
    }
    reset = () => {
        this.__value = 1;
        return this;
    }
}

